import { SVGProps } from '../types';

const YandexIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      d="M31.7334 14.3722C31.6399 13.7948 31.1258 13.4099 30.4248 13.4099C30.1911 13.4099 30.0041 13.4099 29.7704 13.4099C29.3498 13.3618 29.2563 13.5062 29.2563 13.843C29.2563 15.5269 29.2563 17.1627 29.2563 18.8467C29.2563 19.7127 28.415 20.6269 27.4335 20.8193C24.3488 21.541 21.264 22.2146 18.1793 22.9363C17.8521 23.0325 17.4782 23.0325 17.1043 23.0325C16.9641 23.0325 16.7304 22.9363 16.6837 22.792C16.637 22.6957 16.7772 22.5033 16.8706 22.4071C17.0109 22.3108 17.1978 22.2146 17.3848 22.1184C17.9456 21.9259 18.5532 21.7335 19.1141 21.541C21.4043 20.7712 23.6944 20.0014 25.9846 19.1835C27.0129 18.8467 27.5737 18.125 27.5737 17.2109C27.6205 14.3241 27.5737 11.3892 27.5737 8.50241C27.5737 8.02128 27.34 7.63638 26.8259 7.44393C26.2183 7.20336 25.6574 7.39581 25.1433 7.63638C21.8716 9.2241 18.6467 10.8118 15.375 12.3996C14.4402 12.8807 13.8794 13.5543 13.8794 14.5165C13.8794 17.259 13.8794 20.0014 13.8794 22.7438C13.8794 22.8882 13.8794 23.0325 13.9261 23.1288C14.2533 24.0429 15.0946 24.6203 16.2163 24.6203C18.5065 24.6203 20.7967 24.6203 23.0868 24.6203C25.377 24.6203 27.6205 24.6203 29.9106 24.6203C30.4247 24.6203 30.8454 24.524 31.2193 24.1872C31.6867 23.8023 31.6867 23.2731 31.6867 22.792C31.6867 20.4249 31.7334 14.3722 31.7334 14.3722ZM22.1988 13.5062C22.4325 12.8807 22.9466 12.4958 23.6944 12.3996C24.2086 12.3514 24.6292 12.6401 24.7227 13.1213C24.8161 13.843 23.9749 14.709 23.0868 14.709C22.3858 14.709 21.9651 14.1797 22.1988 13.5062Z"
      fill="#FD6727"
    />
  </svg>
);

export { YandexIcon };
